// @flow

import { connect } from 'react-redux';
import { branch, compose, renderNothing, withProps } from 'recompose';
import { get, values } from 'lodash/fp';
import ChallengeInfoModal from 'app/components/challenge/ChallengeInfoModal';
import { fetchGames } from 'app/actions/challengeActions';

const enhance = compose(
  connect(
    (state, { activeSection, challengeId }) => ({
      challenge: get(['challenges', challengeId], state.myChallenges[activeSection]),
      games: state.lobbyChallenges.selectedGames,
      isSignedIn: state.user.isSignedIn,
      lang: state.settings.language
    }),
    {
      fetchGames
    }
  ),
  branch(x => !x.challenge, renderNothing),
  withProps(({ challenge }) => ({
    bonuses: values(challenge.bonuses),
    countries: challenge.countries,
    cost: challenge.cost,
    id: challenge.id,
    isRacing: challenge.isRacing,
    isUnlimited: challenge.isUnlimited,
    labels: challenge.labels,
    link: challenge.link,
    name: challenge.name,
    maxEntriesPerPerson: challenge.maxEntriesPerPerson,
    payout: challenge.payout,
    payoutIcon: challenge.payoutIcon,
    payoutMessage: challenge.payoutLongDescription,
    payoutType: challenge.payoutType,
    prizePool: challenge.prizePool,
    reducedCost: challenge.reducedCost,
    scoring: challenge.scoring,
    startTime: challenge.startTime,
    statusId: challenge.statusId,
    statusLabel: challenge.statusLabel,
    entryCap: challenge.entryCap,
    entryCount: challenge.entryCount
  }))
);

export default enhance(ChallengeInfoModal);
